import { get, post, destroy } from 'config/api'

export const ServicesService = {
    create: (data) => post('/services', data),
    remove: (id) => destroy(`/services/${id}`),
    getServices: () => get('/services')
}